import { render, staticRenderFns } from "./academy-details.vue?vue&type=template&id=18d064fc"
import script from "./academy-details.vue?vue&type=script&lang=js"
export * from "./academy-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports